import React from 'react';
import { Building2 } from 'lucide-react';

export default function SponsoredAdBanner() {
  return (
    <div className="bg-gradient-to-r from-slate-800 to-blue-900 border-t border-slate-700">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          {/* Logo / Brand Area */}
          <div className="flex items-center gap-3">
            <div className="bg-white/10 rounded-lg p-3">
              <Building2 className="w-8 h-8 text-blue-300" />
            </div>
            <div>
              <h3 className="text-white font-bold text-lg tracking-wide">C-Store Realty</h3>
              <p className="text-blue-300 text-xs uppercase tracking-widest">Gas Station Brokerage</p>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-12 bg-white/20" />

          {/* Tagline & Details */}
          <div className="text-center md:text-left max-w-xl">
            <p className="text-white font-medium">
              Southern California's Premier Gas Station & C-Store Brokerage
            </p>
            <p className="text-blue-200 text-sm mt-1.5 leading-relaxed">
              Established in 1996, C-Store Realty has brokered over 675 gas station transactions across the Western U.S., representing major oil companies, independent operators, and national brands including 7-Eleven.
            </p>
          </div>

          {/* Sponsored Label */}
          <div className="md:ml-auto">
            <span className="text-[10px] uppercase tracking-widest text-slate-400 font-medium border border-slate-600 rounded-full px-3 py-1">
              Advertisement
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
